import React from "react";
import { Info as InfoIcon } from "@piiqtechnologies/svg-icons";
import { PeekStack, PeekTooltip, PeekTypography } from "@piiqtechnologies/ui-components";
export const CustomSubtopicHeader = ({ title, subtitle, tooltip }) => {
    return (React.createElement(PeekStack, { direction: "column", gap: 0.5 },
        React.createElement(PeekStack, { direction: "row", gap: 0.5, alignItems: "center" },
            React.createElement(PeekTypography, { variant: "h4", fontWeight: "fontWeightMedium" }, title),
            tooltip && (React.createElement(PeekTooltip, { title: React.createElement(PeekTypography, { variant: "body1" }, tooltip) },
                React.createElement(PeekTypography, { lineHeight: 0 },
                    React.createElement(InfoIcon, null))))),
        React.createElement(PeekTypography, { variant: "body1", color: "info.main" }, subtitle)));
};
